import { Outlet, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { getCurrentUser, clearAuthData } from '@/services/api';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';
import { Button } from '../ui/button';
import { LogOut } from 'lucide-react';

export default function MainLayout() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const user = getCurrentUser();

    const handleLogout = () => {
        queryClient.clear();
        clearAuthData();
        navigate('/login');
    };

    return (
        <div className="flex h-screen bg-gray-50">
            <Sidebar />

            <div className="flex-1 flex flex-col overflow-hidden">
                {/* Header */}
                <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                    {/* Espaço para o botão hambúrguer no mobile */}
                    <h2 className="text-xl font-semibold text-gray-800 ml-12 lg:ml-0">
                        Bem-vindo, {user?.name}!
                    </h2>

                    <div className="flex items-center gap-4">
                        <NotificationBell />

                        <button
                            onClick={() => navigate('/profile')}
                            className="flex items-center gap-3 hover:bg-gray-50 px-3 py-2 rounded-lg transition-colors"
                        >
                            <div className="text-right hidden sm:block">
                                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                                <p className="text-xs text-gray-500">{user?.email}</p>
                            </div>
                            <div className="h-10 w-10 bg-blue-500 rounded-full flex items-center justify-center">
                                <span className="text-white font-semibold">
                                    {user?.name.charAt(0).toUpperCase()}
                                </span>
                            </div>
                        </button>

                        <Button variant="ghost" size="sm" onClick={handleLogout} className="hidden sm:flex">
                            <LogOut className="h-4 w-4" />
                        </Button>
                    </div>
                </header>

                {/* Main Content */}
                <main className="flex-1 overflow-y-auto p-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}